/**
 * Dev-only switch for the homepage component archive.
 *
 * `?dev_home_archive=true` swaps the Home body for the archive of earlier
 * egg-freezing education iterations, so design passes can review them without
 * keeping them on a live Home. A strict no-op outside `__DEV__`.
 */

export const DEV_HOMEPAGE_ARCHIVE: boolean = (() => {
  if (!__DEV__ || typeof window === "undefined") return false;
  const fromUrl = new URLSearchParams(window.location.search).get(
    "dev_home_archive",
  );
  return fromUrl === "true" || fromUrl === "1";
})();
